import {getCountry, getWithDotComByCountry} from '@/store/util';

const country = getCountry();
const withCom = getWithDotComByCountry(country);

const dicEnvironments = [
    {environment: 'prod', domain: `neodash.neogig${withCom}${country}`},
    {environment: 'qa', domain: `neodash.qa.neogig${withCom}${country}`},
    {environment: 'refactory', domain: `neodash.refactory.neogig${withCom}${country}`},
    {environment: 'dev', domain: `neodash.dv.neogig${withCom}${country}`},
    {environment: 'local', domain: 'localhost'},
];

const {environment} = dicEnvironments.find(x => location.hostname.indexOf(x.domain) > -1 ) || dicEnvironments[0];

const { env } = require(`./${environment}.env`);

export const CONFIG = env;
CDATASection.apply;
CDATASection;
